import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Select, Spin, Input, Modal as AntModal } from 'antd';
import {
  DeleteOutlined,
  LeftOutlined,
  RightOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import styled from '@emotion/styled';
import Slider from 'react-slick';
import { projectsServices } from 'services';
import rewards from '../../../../Project/components/Rewards';
import {
  getRewardDescriptionHtml,
  getRewardDescriptionText,
} from 'utils/rewardDescription';

const { Option } = Select;
const FormItem = Form.Item;

/* -------------------- STYLES -------------------- */
const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SectionDescription = styled.span`
  /* Text md/Regular */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: #181d27;


`;

const Wrapper = styled.div`

  .custom-slick-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 18px;
  }

  .custom-slick-dots button {
    width: 18px;
    height: 6px;
    padding: 0;
    border: none;
    border-radius: 999px;
    background: #e9eaeb;
    cursor: pointer;
  }

  .custom-slick-dots button.active {
    background: #9dbc60;
  }
  
  .ant-select-selector {
    border-radius: 8px !important;
    min-height: 44px !important;
    border: 1px solid #d5d7da !important;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05) !important;
    display: flex !important;
    align-items: center !important;
    padding: 0 14px !important;
  }

  .ant-select-selection-placeholder,
  .ant-select-selection-item {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-input,
  .ant-input-affix-wrapper,
  textarea.ant-input {
    border-radius: 8px !important;
    border: 1px solid #d5d7da !important;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05) !important;
    min-height: 44px;
    font-family: 'Inter', sans-serif;
  }

  .ant-form-item {
    margin-bottom: 12px;
  }

  .slick-slider {
    width: 100%;
  }

  .slick-list {
    margin: 0 -8px;
    overflow: hidden;
  }

  .slick-slide > div {
    padding: 0 8px;
    height: 100%;
  }

  /* Slick leaves each slide at its content height by default. Stretch the
     desktop row so ticket cards stay level when their copy wraps differently. */
  .slick-track {
    display: flex;
  }

  .slick-slide {
    float: none;
    height: auto;
  }

  .slick-dots {
    bottom: -28px;
  }

  .slick-dots li {
    width: 18px;
    height: 6px;
    margin: 0 4px;
  }

  .slick-dots li button {
    width: 18px;
    height: 6px;
    padding: 0;
  }

  .slick-dots li button:before {
    content: '';
    width: 18px;
    height: 6px;
    border-radius: 999px;
    background: #e9eaeb;
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    background: #9dbc60;
  }

  @media (max-width: 767px) {
    .slick-list {
      overflow: visible;
    }

    .slick-slide {
      display: flex;
      height: auto !important;
    }

    .slick-slide > div {
      display: flex;
      width: 100%;
    }
  }
`;

const SectionTitle = styled.h3`
  margin: 0 0 6px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
`;

const SectionSubtext = styled.p`
  /* Heading */
  
  /* Text sm/Semibold */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #535862;
`;

const GhostButton = styled.button`
  box-sizing: border-box;
  width: 100%;
  min-height: 44px;
  border: 1px solid #d5d7da;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #414651;
  cursor: pointer;
`;

const ToggleButtonWrap = styled.div`
  margin-bottom: 20px;
`;

const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

const SelectedCard = styled.button`
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  cursor: pointer;
  text-align: left;
`;

const SelectedThumb = styled.div`
  width: 56px;
  min-width: 56px;
  height: 56px;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 0px 16px 0px 16px;

  img {
    border-radius: 0px 16px 0px 16px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const SelectedContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const SelectedTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #181d27;
`;

const SelectedMeta = styled.div`
  margin-top: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
`;

const SelectedPrice = styled.div`
  margin-top: 6px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #181d27;
`;

const RemoveBtn = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  color: #717680;
  cursor: pointer;
  font-size: 18px;
`;

const ExpandArea = styled.div`
  margin-top: 8px;
`;

const TicketMore = styled.div`

  cursor: pointer;
width: 100%;
justify-content: center;
text-align: center;
/* Text md/Semibold */
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 24px;
/* identical to box height, or 150% */
display: flex;
align-items: center;
text-align: center;
text-decoration-line: underline;

color: #9DBC60;

`;
const CardsSectionTitle = styled.h4`
  margin: 0 0 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
`;

const SliderWrap = styled.div`
  position: relative;
  padding-bottom: 28px;
  overflow: hidden;
`;

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ $left }) => ($left ? 'left: -36px;' : 'right: -36px;')}
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #181d27;
  cursor: pointer;
  z-index: 2;

  @media (max-width: 767px) {
    display: none;
  }
`;

const RewardCardWrap = styled.div`
  box-sizing: border-box;
  height: 100%;
  min-height: 510px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
  display: flex !important;
  flex-direction: column;
`;

const RewardImage = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 0 16px 0 16px;

  .blur-background {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(8px);
    transform: scale(1.08);
    opacity: 0.9;
  }

  .blur-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.18);
  }

  .main-image {
    position: absolute;
    inset: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
  }
`;

const RewardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
`;

const RewardTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #181d27;
  min-height: 60px;
`;

const RewardDetails = styled.div`
  margin-top: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #656565;
`;

const RewardAvailability = styled.div`
  margin-top: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #656565;
`;

const RewardPrice = styled.div`
  margin-top: auto;
  padding-top: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #181d27;
`;

const RewardActions = styled.div`
  margin-top: auto;
  display: flex;
  gap: 12px;
  padding-top: 20px;
`;

const DetailButton = styled.button`
  flex: 1;
  box-sizing: border-box;
  height: 48px;
  border: 1px solid #d5d7da;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #414651;
  cursor: pointer;
`;

const ChooseButton = styled.button`
  flex: 1;
  box-sizing: border-box;
  height: 48px;
  border: none;
  background: #9dbc60;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
`;

const LimitText = styled.p`
  margin: 16px 0 0;
  color: #d92d20;
  text-align: center;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
`;

const ModalInner = styled.div`
  position: relative;
  padding-top: 6px;
`;

const ModalClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: transparent;
  font-size: 24px;
  color: #a4a7ae;
  cursor: pointer;
`;

const ModalTitle = styled.h3`
  margin: 0 40px 8px 0;
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  line-height: 40px;
  font-weight: 600;
  color: #181d27;
`;

const ModalText = styled.div`
  margin: 0 0 20px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #535862;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

const ModalImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 12px 0 20px;

  img {
    width: 220px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
  }
`;

const ModalPrice = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #181d27;
  margin-bottom: 4px;
`;

const ModalAvailability = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
  margin-bottom: 20px;
`;

const FieldWrap = styled.div`
  margin-bottom: 14px;
`;

const FieldLabel = styled.div`
  margin-bottom: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #414651;
  font-weight: 500;

  .required {
    color: #9dbc60;
    margin-left: 4px;
  }
`;

const ErrorText = styled.div`
  margin-top: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  line-height: 18px;
  color: #d92d20;
`;

const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  flex-direction: row;
  @media (max-width: 767px) {
    flex-direction: column-reverse;
    height: 100px;
  }
`;

const ModalGhostButton = styled.button`
  flex: 1;
  box-sizing: border-box;
  height: 48px !important;
  border: 1px solid #d5d7da;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #414651;
  cursor: pointer;
`;

const ModalPrimaryButton = styled.button`
  flex: 1;
  box-sizing: border-box;
  height: 48px !important;
  border: none;
  background: #9dbc60;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
`;

/* -------------------- HELPERS -------------------- */

function NextArrow(props) {
  return (
    <ArrowButton onClick={props.onClick}>
      <RightOutlined />
    </ArrowButton>
  );
}

function PrevArrow(props) {
  return (
    <ArrowButton $left onClick={props.onClick}>
      <LeftOutlined />
    </ArrowButton>
  );
}

const getRewardImage = (reward) =>
  reward?.image ||
  reward?.banner ||
  reward?.cover ||
  reward?.thumbnail ||
  '/placeholder.png';

const hasConfiguratorFields = (reward) =>
  (reward?.variants?.length || 0) > 0 ||
  (reward?.questions?.length || 0) > 0 ||
  !!reward?.extra_details;

const getAnswerFieldCount = (reward) => {
  const variantCount = reward?.variants?.length || 0;
  const questionCount = reward?.questions?.length || 0;
  const extraCount = reward?.extra_details ? 1 : 0;
  return variantCount + questionCount + extraCount;
};

const buildEmptyAnswers = (reward, quantity = 1) => {
  const normalizedQuantity = Math.max(1, Number(quantity) || 1);
  return new Array(getAnswerFieldCount(reward) * normalizedQuantity).fill('');
};

const getSelectedRewardsFromStorageOrState = (selectedRewards) => {
  const searchParams = new URLSearchParams(document.location.search);
  const payment_id = searchParams.get('paymentId');
  const payment_intent = searchParams.get('payment_intent');

  if (payment_id != null || payment_intent != null) {
    return JSON.parse(localStorage.getItem('answers')) || [];
  }

  return selectedRewards || [];
};

const getRewardQuantity = (reward) => {
  const quantity = Number(reward?.quantity || 1);
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
};

const getRemainingRewardQuantity = (reward) => {
  const maxCount = Number(reward?.max_order_count || 0);

  if (!maxCount) {
    return 10;
  }

  const booked = Number(reward?.ordered_reward_count || reward?.order_count || 0);
  return Math.max(maxCount - booked, 0);
};

const getQuantityOptions = (reward) => {
  const maxQuantity = getRemainingRewardQuantity(reward);
  return Array.from({ length: Math.max(maxQuantity, 1) }, (_, index) => index + 1);
};

const isLimitedGoodie = (reward, isTicketable) =>
  !isTicketable && Boolean(Number(reward?.max_order_count || 0));

const canSelectRewardQuantity = (reward, isTicketable) =>
  isTicketable || !isLimitedGoodie(reward, isTicketable);

// Keep dropdowns attached to their field while the modal content scrolls.
const getSelectPopupContainer = (triggerNode) =>
  triggerNode.parentElement || document.body;

/* -------------------- COMPONENT -------------------- */

function GoodiesAndTickets({
  projectId,
  originalRewardId,
  setAllRewards,
  setSelectedRewards,
  setAddressRequired,
  allRewards,
  selectedRewards,
  formRef,
  isTicketable,
  recurringCheck,
}) {
  const [loading, setLoading] = useState(false);
  const [showCards, setShowCards] = useState(false);
  const [remainingTicketslimit, setRemainingTicketslimit] = useState(0);
  const [limitReach, setLimitReach] = useState(false);
  const sliderRef = useRef(null);
  const [visibleSlides, setVisibleSlides] = useState(
    window.innerWidth < 768 ? 1 : 2
  );

  useEffect(() => {
    const handleResize = () => {
      setVisibleSlides(window.innerWidth < 768 ? 1 : 2);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [configOpen, setConfigOpen] = useState(false);
  const [configMode, setConfigMode] = useState('add'); // add | edit
  const [configReward, setConfigReward] = useState(null);
  const [configRewardIndex, setConfigRewardIndex] = useState(null);
  const [configErrors, setConfigErrors] = useState({});

  useEffect(() => {
    if (!configOpen) return undefined;

    const { body, documentElement } = document;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyPaddingRight = body.style.paddingRight;
    const previousHtmlOverflow = documentElement.style.overflow;
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;

    body.style.overflow = 'hidden';
    documentElement.style.overflow = 'hidden';

    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      body.style.overflow = previousBodyOverflow;
      body.style.paddingRight = previousBodyPaddingRight;
      documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [configOpen]);

  const effectiveSelectedRewards =
    getSelectedRewardsFromStorageOrState(selectedRewards);

  useEffect(() => {
    if (isTicketable && effectiveSelectedRewards.length === 0) {
      setShowCards(true);
    }
  }, [isTicketable, effectiveSelectedRewards.length]);

  const loadRewardConfiguration = async (reward) => {
    const preparedReward = {
      quantity: 1,
      ...reward,
    };

    const variantsRequest = await projectsServices.getRewardVariants(
      preparedReward.id
    );

    const questionsRequest = await projectsServices.getRewardQuestions(
      preparedReward.id
    );

    preparedReward.variants = variantsRequest?.[preparedReward.id] || [];

    preparedReward.questions = questionsRequest?.[preparedReward.id] || [];

    preparedReward.extra_details = variantsRequest?.extra_details || null;

    preparedReward.address_required =
      variantsRequest?.address_required || false;

    preparedReward.answers = buildEmptyAnswers(preparedReward);

    return preparedReward;
  };

  useEffect(() => {
    let mounted = true;
    async function loadRewards() {
      setLoading(true);
      try {
        let rewards = await projectsServices.getProjectRewards(projectId);
        rewards = rewards.filter((reward) => {
          return !(
            reward.max_order_count &&
            reward.order_count &&
            reward.order_count >= reward.max_order_count
          );
        });

        if (!mounted) return;

        setAllRewards(rewards);
      } catch (e) {
        console.log(e);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadRewards();
    return () => {
      mounted = false;
    };
  }, [projectId, originalRewardId]);

  useEffect(() => {
    if (originalRewardId !== 0) {
      const elementIndex = allRewards.findIndex(
        (x) => x.id === originalRewardId
      );
      if (elementIndex !== -1) {
        handleChooseReward(elementIndex);
      }
    }
  }, [originalRewardId, allRewards]);
  const sliderSettings = {
    dots: false,

    infinite: allRewards.length > 2,

    speed: 400,

    slidesToShow: 2,

    slidesToScroll: 2,

    arrows: allRewards.length > 2,

    nextArrow: <NextArrow />,

    prevArrow: <PrevArrow />,

    afterChange: (current) => {
      setCurrentSlide(current);
    },

    responsive: [
      {
        breakpoint: 768,

        settings: {
          slidesToShow: allRewards.length > 1 ? 1.25 : 1,

          slidesToScroll: 1,

          arrows: false,

          infinite: false,

          afterChange: (current) => {
            setCurrentSlide(current);
          },
        },
      },
    ],
  };

  const getVisibleDotStart = () => {
    if (!allRewards.length) return 0;

    const maxStart = Math.max(allRewards.length - visibleSlides, 0);
    const normalizedCurrentSlide =
      ((currentSlide % allRewards.length) + allRewards.length) %
      allRewards.length;

    return Math.min(normalizedCurrentSlide, maxStart);
  };

  const visibleDotStart = getVisibleDotStart();

  const syncRewardIdUrl = (ids) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (ids.length) {
      params.set('rewardId', ids.join(','));
    } else {
      params.delete('rewardId');
    }

    window.history.replaceState({}, '', url.toString());
  };

  const openConfigModal = (reward, mode = 'add', index = null) => {
    const preparedReward = {
      quantity: 1,
      ...reward,
      answers: Array.isArray(reward.answers)
        ? [...reward.answers]
        : buildEmptyAnswers(reward),
    };

    setConfigMode(mode);
    setConfigReward(preparedReward);
    setConfigRewardIndex(index);
    setConfigErrors({});
    setConfigOpen(true);
  };

  const closeConfigModal = () => {
    setConfigOpen(false);
    setConfigReward(null);
    setConfigRewardIndex(null);
    setConfigErrors({});
  };

  const handleConfigValueChange = (value, answerIndex) => {
    setConfigReward((prev) => {
      const next = { ...prev };
      const answers = Array.isArray(next.answers) ? [...next.answers] : [];
      answers[answerIndex] = value;
      next.answers = answers;
      return next;
    });

    setConfigErrors((prev) => {
      const next = { ...prev };
      delete next[answerIndex];
      return next;
    });
  };

  const handleQuantityChange = (quantity) => {
    setConfigReward((prev) => {
      const normalizedQuantity = Math.max(1, Number(quantity) || 1);
      const nextAnswers = buildEmptyAnswers(prev, normalizedQuantity);
      const currentAnswers = Array.isArray(prev.answers) ? prev.answers : [];

      currentAnswers
        .slice(0, nextAnswers.length)
        .forEach((answer, index) => {
          nextAnswers[index] = answer;
        });

      return {
        ...prev,
        quantity: normalizedQuantity,
        answers: nextAnswers,
      };
    });
  };

  const validateConfig = () => {
    if (!configReward) return false;

    const errors = {};
    const fieldCount = getAnswerFieldCount(configReward);
    const quantity = getRewardQuantity(configReward);

    for (let ticketIndex = 0; ticketIndex < quantity; ticketIndex += 1) {
      for (let fieldOffset = 0; fieldOffset < fieldCount; fieldOffset += 1) {
        const answerIndex = ticketIndex * fieldCount + fieldOffset;
        const value = configReward.answers?.[answerIndex];

        if (value == null || value === '') {
          errors[answerIndex] = 'Deine Antwort ist erforderlich';
        }
      }
    }

    setConfigErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const persistSelectedRewards = (list) => {
    setSelectedRewards(list);
    syncRewardIdUrl(list.map((reward) => reward.id));
    setAddressRequired(list);
    if (list.length === 0) {
      localStorage.removeItem('answers');
    } else {
      localStorage.setItem('answers', JSON.stringify(list));
    }
  };

  const confirmConfigModal = () => {
    if (!configReward) return;

    if (hasConfiguratorFields(configReward) && !validateConfig()) return;

    const normalizedConfigReward = {
      ...configReward,
      quantity: canSelectRewardQuantity(configReward, isTicketable)
        ? getRewardQuantity(configReward)
        : 1,
    };

    if (configMode === 'edit' && configRewardIndex != null) {
      const updated = [...effectiveSelectedRewards];
      const previousQuantity = getRewardQuantity(updated[configRewardIndex]);
      updated[configRewardIndex] = normalizedConfigReward;
      persistSelectedRewards(updated);
      setRemainingTicketslimit((prev) =>
        Math.max(
          0,
          prev - previousQuantity + getRewardQuantity(normalizedConfigReward)
        )
      );
      closeConfigModal();
      return;
    }

    const updated = [
      ...effectiveSelectedRewards,
      {
        ...normalizedConfigReward,
      },
    ];
    persistSelectedRewards(updated);

    if (normalizedConfigReward.no_multi_order && configRewardIndex != null) {
      const removed = [...allRewards];
      removed.splice(configRewardIndex, 1);
      setAllRewards(removed);
    }

    const max_count = normalizedConfigReward?.max_order_count;
    const booked = normalizedConfigReward?.ordered_reward_count;
    const limit = max_count - booked;

    if (limit != null && max_count != null && booked != null) {
      setRemainingTicketslimit(
        (prev) => prev + getRewardQuantity(normalizedConfigReward)
      );
      setLimitReach(false);
    }

    setShowCards(false);

    closeConfigModal();
  };

  const handleChooseReward = async (index) => {
    const reward = { ...allRewards[index] };
    const existingSelectedIndex = effectiveSelectedRewards.findIndex(
      (selectedReward) => selectedReward.id === reward.id
    );

    if (existingSelectedIndex !== -1) {
      openConfigModal(
        effectiveSelectedRewards[existingSelectedIndex],
        'edit',
        existingSelectedIndex
      );
      return;
    }

    const max_count = reward?.max_order_count;
    const booked = reward?.ordered_reward_count;
    const limit = max_count - booked;

    if (limit != null && max_count != null && booked != null) {
      if (limit <= remainingTicketslimit) {
        setLimitReach(true);
        return;
      }
    }

    setLoading(true);

    try {
      const preparedReward = await loadRewardConfiguration(reward);

      setConfigMode('add');
      setConfigRewardIndex(index);
      setConfigReward(preparedReward);
      setConfigErrors({});
      setConfigOpen(true);
      setShowCards(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveReward = (index) => {
    setLoading(true);

    const selectedReward = effectiveSelectedRewards[index];

    const removedSelected = effectiveSelectedRewards.filter(
      (_, i) => i !== index
    );

    persistSelectedRewards(removedSelected);

    if (selectedReward?.no_multi_order) {
      const alreadyExists = allRewards.some(
        (reward) => reward.id === selectedReward.id
      );

      if (!alreadyExists) {
        setAllRewards([...allRewards, selectedReward]);
      }
    }

    const max_count = selectedReward?.max_order_count;
    const booked = selectedReward?.ordered_reward_count;
    const limit = max_count - booked;

    if (limit != null && max_count != null && booked != null) {
      setRemainingTicketslimit((prev) =>
        Math.max(0, prev - getRewardQuantity(selectedReward))
      );
      setLimitReach(false);
    }

    if (!removedSelected.length) {
      setShowCards(false);
    }

    formRef?.current?.resetFields?.();
    setLoading(false);
  };
  const handleDetailsReward = async (index) => {
    const reward = { ...allRewards[index] };
    setLoading(true);

    try {
      const preparedReward = await loadRewardConfiguration(reward);

      setConfigMode('add');
      setConfigRewardIndex(index);
      setConfigReward(preparedReward);
      setConfigErrors({});
      setConfigOpen(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditReward = async (index) => {
    const reward = effectiveSelectedRewards[index];

    if (!reward) return;

    openConfigModal(reward, 'edit', index);
  };

  const renderRewardCard = (reward, i) => {
    const image = getRewardImage(reward);
    const description = getRewardDescriptionText(reward);

    return (
      <RewardCardWrap key={reward.id || i}>
        <RewardImage>
          <img
            className="blur-background"
            src={image}
            alt=""
            aria-hidden="true"
          />
          <div className="blur-overlay" />
          <img className="main-image" src={image} alt={reward.title} />
        </RewardImage>

        <RewardContent>
          <RewardTitle>{reward.title}</RewardTitle>

          <RewardDetails>
            {reward?.variants?.length
              ? `Varianten: ${reward?.variants
                  .map((variant) => variant.attribute)
                  .join(', ')}`
              : description
                  .split(' ')
                  .slice(0, 10)
                  .join(' ')}
          </RewardDetails>

          <RewardAvailability>
            {reward?.max_order_count && reward?.ordered_reward_count != null
              ? `${reward.ordered_reward_count} von ${reward.max_order_count} gebucht`
              : 'Noch verfügbar'}
          </RewardAvailability>

          <RewardPrice>
            {parseFloat(reward.price || 0).toFixed(2)} €
          </RewardPrice>
        </RewardContent>

        <RewardActions>
          <DetailButton type="button" onClick={() => handleDetailsReward(i)}>
            Details
          </DetailButton>

          <ChooseButton type="button" onClick={() => handleChooseReward(i)}>
            Auswählen
          </ChooseButton>
        </RewardActions>
      </RewardCardWrap>
    );
  };

  const renderConfigFields = () => {
    if (!configReward) return null;

    const fields = [];
    const quantity = getRewardQuantity(configReward);
    const fieldCount = getAnswerFieldCount(configReward);

    if (canSelectRewardQuantity(configReward, isTicketable)) {
      fields.push(
        <FieldWrap key="reward-quantity">
          <FieldLabel>Menge</FieldLabel>

          <Select
            value={quantity}
            onChange={handleQuantityChange}
            getPopupContainer={getSelectPopupContainer}
            size="large"
          >
            {getQuantityOptions(configReward).map((optionQuantity) => (
              <Option key={optionQuantity} value={optionQuantity}>
                {optionQuantity}
              </Option>
            ))}
          </Select>
        </FieldWrap>
      );
    }

    for (let ticketIndex = 0; ticketIndex < quantity; ticketIndex += 1) {
      let cursor = ticketIndex * fieldCount;
      const ticketLabel = quantity > 1 ? `Ticket ${ticketIndex + 1}: ` : '';

      if (configReward?.variants?.length) {
        configReward.variants.forEach((variant, idx) => {
          const fieldIndex = cursor;
          fields.push(
            <FieldWrap key={`ticket-${ticketIndex}-variant-${idx}`}>
              <FieldLabel>
                {ticketLabel}{variant.attribute}
                <span className="required">*</span>
              </FieldLabel>

              {variant?.options?.length ? (
                <>
                  <Select
                    placeholder={`${variant.attribute} auswählen`}
                    value={configReward.answers?.[fieldIndex] || undefined}
                    onChange={(value) =>
                      handleConfigValueChange(value, fieldIndex)
                    }
                    getPopupContainer={getSelectPopupContainer}
                    size="large"
                  >
                    {variant.options.map((option, k) => (
                      <Option key={k} value={option}>
                        {option}
                      </Option>
                    ))}
                  </Select>
                  {configErrors[fieldIndex] && (
                    <ErrorText>{configErrors[fieldIndex]}</ErrorText>
                  )}
                </>
              ) : (
                <>
                  <Input
                    placeholder={variant.attribute}
                    value={configReward.answers?.[fieldIndex] || ''}
                    onChange={(e) =>
                      handleConfigValueChange(e.target.value, fieldIndex)
                    }
                    size="large"
                  />
                  {configErrors[fieldIndex] && (
                    <ErrorText>{configErrors[fieldIndex]}</ErrorText>
                  )}
                </>
              )}
            </FieldWrap>
          );
          cursor += 1;
        });
      }

      if (configReward?.questions?.length) {
        configReward.questions.forEach((question, idx) => {
          const fieldIndex = cursor;
          const label = Array.isArray(question) ? question[0] : 'Frage';

          fields.push(
            <FieldWrap key={`ticket-${ticketIndex}-question-${idx}`}>
              <FieldLabel>
                {ticketLabel}{label}
                <span className="required">*</span>
              </FieldLabel>

              {Array.isArray(question) &&
              question.length > 1 &&
              question[1] !== '' ? (
                <>
                  <Select
                    placeholder={label}
                    value={configReward.answers?.[fieldIndex] || undefined}
                    onChange={(value) =>
                      handleConfigValueChange(value, fieldIndex)
                    }
                    getPopupContainer={getSelectPopupContainer}
                    size="large"
                  >
                    {question.map((answer, k) =>
                      k !== 0 ? (
                        <Option key={k} value={answer}>
                          {answer}
                        </Option>
                      ) : null
                    )}
                  </Select>
                  {configErrors[fieldIndex] && (
                    <ErrorText>{configErrors[fieldIndex]}</ErrorText>
                  )}
                </>
              ) : (
                <>
                  <Input
                    placeholder={label}
                    value={configReward.answers?.[fieldIndex] || ''}
                    onChange={(e) =>
                      handleConfigValueChange(e.target.value, fieldIndex)
                    }
                    size="large"
                  />
                  {configErrors[fieldIndex] && (
                    <ErrorText>{configErrors[fieldIndex]}</ErrorText>
                  )}
                </>
              )}
            </FieldWrap>
          );

          cursor += 1;
        });
      }

      if (configReward?.extra_details) {
        const fieldIndex = cursor;
        fields.push(
          <FieldWrap key={`ticket-${ticketIndex}-extra-details`}>
            <FieldLabel>
              {ticketLabel}{configReward.extra_details}
              <span className="required">*</span>
            </FieldLabel>

            <Input
              placeholder={configReward.extra_details}
              value={configReward.answers?.[fieldIndex] || ''}
              onChange={(e) =>
                handleConfigValueChange(e.target.value, fieldIndex)
              }
              size="large"
            />

            {configErrors[fieldIndex] && (
              <ErrorText>{configErrors[fieldIndex]}</ErrorText>
            )}
          </FieldWrap>
        );
      }
    }

    return fields;
  };
  if (allRewards.length === 0 && effectiveSelectedRewards?.length === 0) {
    return <></>;
  }
  return (
    <Section>
      <Spin spinning={loading}>
        <Wrapper>
          <SectionTitle>{isTicketable ? 'Tickets' : 'Goodies'}</SectionTitle>
          {effectiveSelectedRewards?.length < 1 && !isTicketable && (
            <SectionDescription>
              Möchtest du noch Goodies hinzufügen?
            </SectionDescription>
          )}

          {effectiveSelectedRewards?.length > 0 && (
            <>
              <SectionSubtext>Deine Auswahl</SectionSubtext>

              <SelectedList>
                {effectiveSelectedRewards.map((reward, i) => {
                  const image = getRewardImage(reward);
                  const quantity = getRewardQuantity(reward);
                  const itemTotal = Number(reward.price || 0) * quantity;

                  return (
                    <SelectedCard
                      key={`${reward.id || i}-${i}`}
                      type="button"
                      onClick={() => handleEditReward(i)}
                    >
                      <SelectedThumb>
                        <img src={image} alt={reward.title} />
                      </SelectedThumb>

                      <SelectedContent>
                        <SelectedTitle>{reward.title}</SelectedTitle>

                        <SelectedMeta>Menge: {quantity}</SelectedMeta>

                        {reward?.answers?.filter(Boolean)?.length > 0 && (
                          <SelectedMeta>
                            {reward.answers.filter(Boolean).map((item, idx) => (
                              <div key={idx}>{item}</div>
                            ))}
                          </SelectedMeta>
                        )}

                        <SelectedPrice>
                          {parseFloat(itemTotal || 0).toFixed(2)} €
                        </SelectedPrice>
                      </SelectedContent>

                      <RemoveBtn
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveReward(i);
                        }}
                      >
                        <DeleteOutlined />
                      </RemoveBtn>
                    </SelectedCard>
                  );
                })}
              </SelectedList>
            </>
          )}

          {/*{effectiveSelectedRewards?.length > 0 && allRewards?.length > 0 && (*/}
          {/*  <SectionSubtext>*/}
          {/*    Möchtest du noch {isTicketable ? 'Tickets' : 'Goodies'} hinzufügen?*/}
          {/*  </SectionSubtext>*/}
          {/*)}*/}

          {allRewards?.length > 0 && (
            <ToggleButtonWrap>
              {isTicketable ? (
                !showCards && (
                  <TicketMore onClick={() => setShowCards((p) => !p)}>
                    Weitere Tickets hinzufügen
                  </TicketMore>
                )
              ) : (
                <GhostButton
                  type="button"
                  onClick={() => setShowCards((p) => !p)}
                >
                  {showCards
                    ? `${isTicketable ? 'Tickets' : 'Goodies'} ausblenden`
                    : `${isTicketable ? 'Tickets' : 'Goodies'} anzeigen`}
                </GhostButton>
              )}
            </ToggleButtonWrap>
          )}

          {showCards && !!allRewards?.length && (
            <ExpandArea>
              {effectiveSelectedRewards?.length > 0 && (
                <CardsSectionTitle>
                  Weitere {isTicketable ? 'Tickets' : 'Goodies'} hinzufügen
                </CardsSectionTitle>
              )}
              <SliderWrap>
                <Slider ref={sliderRef} {...sliderSettings}>
                  {allRewards.map((reward, i) => renderRewardCard(reward, i))}
                </Slider>
                <div className="custom-slick-dots">
                  {allRewards.map((_, index) => {
                    const isActive =
                      index >= visibleDotStart &&
                      index < visibleDotStart + visibleSlides;

                    return (
                      <button
                        key={index}
                        type="button"
                        className={isActive ? 'active' : ''}
                        onClick={() => sliderRef.current?.slickGoTo(index)}
                      />
                    );
                  })}
                </div>
              </SliderWrap>

              {limitReach && (
                <LimitText>
                  {isTicketable
                    ? 'Ticket-Limit erreicht'
                    : 'Goodie-Limit erreicht'}
                </LimitText>
              )}
            </ExpandArea>
          )}

          <AntModal
            open={configOpen}
            footer={null}
            closable={false}
            onCancel={closeConfigModal}
            width={520}
            centered
            destroyOnClose
            bodyStyle={{
              maxHeight: 'calc(100vh - 64px)',
              overflowY: 'auto',
              overscrollBehavior: 'contain',
            }}
          >
            {configReward && (
              <ModalInner>
                <ModalClose type="button" onClick={closeConfigModal}>
                  <CloseOutlined />
                </ModalClose>

                <ModalTitle>{configReward.title}</ModalTitle>

                <ModalText
                  dangerouslySetInnerHTML={{
                    __html: getRewardDescriptionHtml(
                      configReward,
                      'Bitte triff deine Auswahl, um fortzufahren.'
                    ),
                  }}
                />

                <ModalImageWrap>
                  <img
                    src={getRewardImage(configReward)}
                    alt={configReward.title}
                  />
                </ModalImageWrap>

                <ModalPrice>
                  {parseFloat(configReward.price || 0).toFixed(2)} €
                </ModalPrice>

                <ModalAvailability>
                  {configReward?.max_order_count &&
                  configReward?.ordered_reward_count != null
                    ? `${configReward.ordered_reward_count} von ${configReward.max_order_count} gebucht`
                    : 'Noch verfügbar'}
                </ModalAvailability>

                {renderConfigFields()}

                <ModalFooter>
                  <ModalGhostButton type="button" onClick={closeConfigModal}>
                    Schließen
                  </ModalGhostButton>

                  <ModalPrimaryButton
                    type="button"
                    onClick={confirmConfigModal}
                  >
                    {configMode === 'edit' ? 'Speichern' : 'Auswählen'}
                  </ModalPrimaryButton>
                </ModalFooter>
              </ModalInner>
            )}
          </AntModal>
        </Wrapper>
      </Spin>
    </Section>
  );
}

GoodiesAndTickets.propTypes = {
  projectId: PropTypes.string.isRequired,
  originalRewardId: PropTypes.number,
  donationLessThenFive: PropTypes.bool,
  setAllRewards: PropTypes.func.isRequired,
  setSelectedRewards: PropTypes.func.isRequired,
  setAddressRequired: PropTypes.func.isRequired,
  allRewards: PropTypes.array,
  selectedRewards: PropTypes.array,
  handleCLientSecret: PropTypes.func,
  formRef: PropTypes.object,
  isTicketable: PropTypes.bool,
};

GoodiesAndTickets.defaultProps = {
  originalRewardId: 0,
  donationLessThenFive: false,
  allRewards: [],
  selectedRewards: [],
  isTicketable: false,
};

export default GoodiesAndTickets;
